import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	DestroyRef,
	EventEmitter,
	Input,
	Output,
	inject,
	OnInit,
} from '@angular/core';
import { IDroppedFile } from '@shared/ui-components/au-file-loader/au-file-loader.interfaces';
import { SelectionModel } from '@angular/cdk/collections';
import { FileSelectionsService } from '../services/file-selections.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { FileCardComponent } from '../../../../pages/cmms/components/files/files/file-card/file-card.component';

@Component({
	selector: 'file-cards-list',
	templateUrl: './file-cards-list.component.html',
	styleUrls: ['./file-cards-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [FileCardComponent],
})
export class FileCardsListComponent implements OnInit {
	private readonly destroyRef = inject(DestroyRef);
	private readonly fileSelectionService = inject(FileSelectionsService);
	private readonly cdr = inject(ChangeDetectorRef);

	@Input() filesData: Partial<IDroppedFile>[];
	@Input() title: string;
	@Input() allowDelete = true;
	@Input() selection = new SelectionModel<Partial<IDroppedFile>>(true, []);
	@Output() openFile = new EventEmitter<number>();
	@Output() deleteFile = new EventEmitter<number>();

	ngOnInit() {
		this.fileSelectionService.selectionClear$
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(() => {
				this.selection.clear();
				this.cdr.detectChanges();
			});
	}
}
